// cleanup_convert_to_typescript_file_TRANSFERS
// cleanup_remove_external_libraries_TRANSFERS

import { isEmpty, template } from 'lodash';

import { numberToCurrency } from 'utils/currency';
import { sortAccounts, ACCOUNT_TYPES } from 'constants.js';
import { BALANCE_TYPES, LOAN_ACCOUNT } from './SingleTransfer.constants';

const { CURRENT_AVAILABLE, CURRENT_PRINCIPAL } = BALANCE_TYPES;

export const getBalance = (accountType, id) =>
  id ? accountType.find((acct) => acct.id === id).balance : '';

export const formatBalance = (accounts, id, locale) => {
  const balance = getBalance(accounts, id);
  const formattedBalance = numberToCurrency(balance);
  const message = template(locale['common.usdAvailable'])({
    amount: formattedBalance
  });
  return balance && message;
};
const getBalanceType = (accountType, typeCategory) =>
  accountType === ACCOUNT_TYPES.CREDIT && typeCategory.toLowerCase() === LOAN_ACCOUNT
    ? CURRENT_PRINCIPAL
    : CURRENT_AVAILABLE;

export const getBalanceLabel = ({ typeCategory }, accountType, locale) => {
  const balanceType = getBalanceType(accountType, typeCategory);

  const balanceLabelMap = {
    [CURRENT_AVAILABLE]: locale['common.available'],
    [CURRENT_PRINCIPAL]: locale['common.outstandingBalance']
  };

  return balanceLabelMap[balanceType];
};

export const formatOption =
  (locale) =>
  (accountType) =>
  ({ allBalances = [], balance, id, name: defaultName, nickname, number, typeCategory }) => {
    const balanceType = getBalanceType(accountType, typeCategory);
    const balanceLabel = getBalanceLabel({ typeCategory }, accountType, locale);

    const accountBalance =
      (allBalances || [])?.filter((bal) => bal.label === balanceType)?.[0]?.amount || balance;

    const formattedBalance =
      accountBalance === null
        ? locale['common.grid.empty']
        : `${numberToCurrency(accountBalance)} ${balanceLabel}`.trim();

    const formattedDisplayName = nickname ? `${nickname} - ` : `${defaultName} - `;
    const shortName = `${formattedDisplayName}${number}`;
    const name = `${shortName} (${formattedBalance})`;

    return {
      name,
      balance: accountBalance,
      displayName: defaultName,
      shortName,
      standardName: nickname || defaultName,
      number,
      id,
      type: accountType
    };
  };

export const createDropdown = (locale, accounts, selected, accountType) =>
  sortAccounts([...accounts].filter(({ id }) => id && id !== selected)).map(
    formatOption(locale)(accountType)
  );

export const checkIsValid = (formData, name, valid) =>
  formData.isValid[name] === undefined
    ? formData.isValid
    : {
        ...formData.isValid,
        [name]: valid
      };

export const updateRecurring = ({ recurring }, date) => ({
  recurring: {
    ...recurring,
    startDate: date
  }
});

export const getCurrencySymbol = (debitAccounts, locale) => {
  const currency = !isEmpty(debitAccounts) && debitAccounts[0].currency;
  const isUSD = currency && currency === locale['common.usd'];
  const sign = !isUSD ? currency : locale['common.currencySymbol'];
  return currency ? sign : '';
};
